export default __webpack_public_path__ + "static/media/SC-GN01-2.905cacf7.jpg";